import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import config from './common/config'
import * as common from './common'
import './style/theme.less'
import './style/global.css'
// antdvLibs
import antdvLibs from 'antdv-libs'
import 'antdv-libs/lib/AntdvLibs.css'
import * as apis from './apis'

import * as echarts from 'echarts';
// iconfont库
import '@/assets/iconfont/iconfont.css';

//富文本
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)
Vue.prototype.$common = common
Vue.use(antdvLibs, { settings: config })
Vue.use(ElementUI);
Vue.use(Antd);
Vue.config.productionTip = false
Vue.prototype.$apis = apis
Vue.prototype.$echarts = echarts;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
